import { type RatingLabel } from '@libraries/typescript/api_client/schema_types';

export const VOICE_QA_VERDICT_BADGES: Record<
    RatingLabel,
    { readonly label: string; readonly className: string }
> = {
    perfect: { label: 'Perfect', className: 'text-emerald-700' },
    good: { label: 'Good', className: 'text-green-700' },
    bad: { label: 'Bad', className: 'text-red-700' },
};
